import React from "react";
import CartItem from "./item";
import { useCart } from "hooks/useStore";
import EmptyCart from "./empty";
import CartUpsells from "./upsells";
import DiscountTiers from "./discount-tiers";
import { sortCartItems } from "utils/cart";

const CartBody = ({ upsellProducts, warrantyProducts, discountTiers }) => {
	const { items } = useCart(["items"]);
	const sortedItems = sortCartItems(items);

	return (
		<div className="overflow-y-auto overflow-x-visible box-border flex-[6] pb-5 bg-white">
			<DiscountTiers className="my-2 px-4" data={discountTiers} />
			{items?.length > 0 ? (
				<div className="flex flex-col gap-5">
					<div className="relative px-4">
						{sortedItems.map((item, index) =>
							<CartItem key={`${item.variant.id}-${index + 1}`} product={item} warrantyProducts={warrantyProducts} />)}
					</div>
					<CartUpsells />
				</div>
			) : <EmptyCart upsellProducts={upsellProducts} />
			}
		</div >
	);
};

export default CartBody;